import Column_DesignedColumnComponent from '@wix/thunderbolt-elements/src/components/Column/viewer/skinComps/DesignedColumn/DesignedColumn.skin';


const Column_DesignedColumn = {
  component: Column_DesignedColumnComponent
};


export const components = {
  ['Column_DesignedColumn']: Column_DesignedColumn
};

